import React from 'react';

const Severability: React.FC = () => {
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-2">Severability</h4>
      <p>If any provision of these terms is found to be unenforceable or invalid:</p>
      
      <ul className="list-disc pl-5 space-y-2">
        <li>Such provision will be changed and interpreted to accomplish the objectives of the provision to the greatest extent possible</li>
        <li>Remaining provisions will continue in full force and effect</li>
        <li>Invalid terms will be severed without affecting other terms</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Waiver</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>No waiver of any term shall be deemed a further or continuing waiver</li>
        <li>Failure to assert any right or provision is not a waiver</li>
        <li>All waivers must be in writing and signed</li>
        <li>Single instance waivers do not constitute ongoing waiver</li>
      </ul>
    </div>
  );
};

export default Severability;